import { useCallback, useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"
import { useToast } from "@hooks"
import { reportListData } from "Pages/ReportsAlerts/Reports/@signals"

export default function useDeleteReport(idReport, name) {
	const { backendUrl } = useReportBackendApiPath()
	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const setIsLoading = () => isLoading.value = true

	const onDelete = useCallback(() => showToast.confirm(`Are you sure you want to delete the report titled '${name}'? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			showToast.promise(postSubmit(`${backendUrl}/delete`, { idReport, }),
				{
					onSuccess: () => {
						reportListData.value = [...reportListData.value.filter(item => item.idReport !== idReport)]
						isLoading.value = false
					},
					onCancel: () => isLoading.value = false
				})
		}
	}), [idReport])

	useEffect(() => {
		if (isLoading.value) onDelete()
	}, [isLoading.value])

	return {
		setIsLoading,
		isLoading: isLoading.value
	}

}